<template>
  <div>
    <el-alert
      title="审核按类型增减现存量并写库存流水；领料/发货若有同来源预留则消耗占用。明细可选托盘。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.documentCode" clearable placeholder="单据号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.documentType" clearable placeholder="类型" style="width:130px">
        <el-option v-for="t in types" :key="t.value" :label="t.label" :value="t.value" />
      </el-select>
      <el-select v-model="query.approveStatus" clearable placeholder="审核状态" style="width:120px">
        <el-option label="未审核" value="0" />
        <el-option label="已审核" value="2" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button @click="openGenerate">按工单领料</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="documentCode" label="单据号" width="180" />
      <el-table-column prop="documentTypeName" label="类型" width="100" />
      <el-table-column prop="documentDate" label="单据日期" width="110" />
      <el-table-column prop="orderCode" label="工单号" width="140" show-overflow-tooltip />
      <el-table-column prop="fromWareHouseName" label="出库仓" width="120" show-overflow-tooltip />
      <el-table-column prop="toWareHouseName" label="入库仓" width="120" show-overflow-tooltip />
      <el-table-column prop="totalQuantity" label="合计数量" width="100" align="right" />
      <el-table-column label="来源" width="110" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ sourceLabel(row.sourceType) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.approveStatus === '2' ? 'success' : 'info'">{{ row.approveStatus === '2' ? '已审核' : '未审核' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createByName" label="制单人" width="90" />
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="操作" width="230" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openView(row.documentId)">查看</el-button>
          <el-button type="text" :disabled="row.approveStatus !== '0'" @click="openEdit(row.documentId)">修改</el-button>
          <el-button type="text" :disabled="row.approveStatus !== '0'" @click="approveRow(row.documentId)">审核</el-button>
          <el-button type="text" :disabled="row.approveStatus !== '2'" @click="unapproveRow(row.documentId)">弃审</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.approveStatus !== '0'" @click="onDelete(row.documentId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="1080px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="单据类型">
              <el-select v-model="form.documentType" :disabled="readonly || !!form.documentId" style="width:100%">
                <el-option v-for="t in types" :key="t.value" :label="t.label" :value="t.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8"><el-form-item label="单据号"><el-input v-model="form.documentCode" placeholder="留空自动生成" /></el-form-item></el-col>
          <el-col :span="8">
            <el-form-item label="单据日期">
              <el-date-picker v-model="form.documentDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col v-if="needFrom" :span="8">
            <el-form-item :label="fromLabel">
              <el-select v-model="form.fromWareHouseId" filterable style="width:100%">
                <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="needTo" :span="8">
            <el-form-item :label="toLabel">
              <el-select v-model="form.toWareHouseId" filterable style="width:100%">
                <el-option v-for="w in warehouses" :key="'t'+w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工单">
              <el-select v-model="form.orderId" filterable clearable placeholder="可选" style="width:100%">
                <el-option v-for="o in orders" :key="o.orderId" :label="o.orderCode + (o.orderName ? ' / ' + o.orderName : '')" :value="o.orderId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item></el-col>
        </el-row>
        <el-button v-if="!readonly" type="primary" size="mini" @click="addLine">添加明细</el-button>
        <el-table :data="form.lineList" border size="small" style="margin-top:8px">
          <el-table-column label="产品" min-width="200">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.productNumber ? (row.productNumber + (row.productName ? ' / ' + row.productName : '')) : productLabel(row.productId) }}</span>
              <el-select v-else v-model="row.productId" filterable size="mini" style="width:100%">
                <el-option v-for="p in products" :key="p.productId" :label="p.productNumber + ' / ' + (p.productName || '')" :value="p.productId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column v-if="form.documentType !== '03'" label="仓库" width="150">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.wareHouseName || wareHouseLabel(row.wareHouseId) }}</span>
              <el-select v-else v-model="row.wareHouseId" filterable clearable size="mini" placeholder="覆盖头仓" style="width:100%">
                <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="库位" width="140">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.wareAreaName || row.wareAreaId || '-' }}</span>
              <el-select v-else v-model="row.wareAreaId" filterable clearable size="mini" placeholder="可选" style="width:100%" @focus="loadAreas(lineWh(row))">
                <el-option v-for="a in areasOf(row)" :key="a.wareAreaId" :label="a.wareAreaName" :value="a.wareAreaId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="批次" width="110">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.batchNo || '-' }}</span>
              <el-input v-else v-model="row.batchNo" size="mini" placeholder="可选" />
            </template>
          </el-table-column>
          <el-table-column label="托盘" width="140">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ palletLabel(row.palletId) }}</span>
              <el-select v-else v-model="row.palletId" filterable clearable size="mini" placeholder="可选" style="width:100%">
                <el-option v-for="p in pallets" :key="p.palletId" :label="p.palletCode + (p.palletName ? ' / ' + p.palletName : '')" :value="p.palletId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="130">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.quantity }}</span>
              <el-input-number v-else v-model="row.quantity" :min="0" :precision="5" size="mini" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="操作" width="70" align="center">
            <template slot-scope="{ $index }"><el-button type="text" size="mini" @click="form.lineList.splice($index, 1)">删除</el-button></template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="按工单生成领料单" :visible.sync="genVisible" width="560px" :close-on-click-modal="false">
      <el-form label-width="100px">
        <el-form-item label="工单">
          <el-select v-model="genForm.orderId" filterable clearable placeholder="请选择工单" style="width:100%">
            <el-option v-for="o in orders" :key="o.orderId" :label="o.orderCode + (o.orderName ? ' / ' + o.orderName : '')" :value="o.orderId" />
          </el-select>
        </el-form-item>
        <el-form-item label="领料仓库">
          <el-select v-model="genForm.fromWareHouseId" filterable placeholder="请选择仓库" style="width:100%">
            <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="genVisible = false">取消</el-button>
        <el-button type="primary" @click="doGenerate">生成草稿</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listStockDocument, getStockDocument, saveStockDocument, updateStockDocument, deleteStockDocument,
  approveStockDocument, unapproveStockDocument, generateIssueFromOrder
} from '../../api/stockDocument'
import { selectEnabledWareHouse, listWareArea } from '../../api/warehouse'
import { selectProductionOrder } from '../../api/productionOrder'
import { selectProduct } from '../../api/product'
import { selectPallet } from '../../api/pallet'

function emptyForm() {
  return {
    documentId: '', documentCode: '', documentType: '01', documentDate: null,
    orderId: '', fromWareHouseId: '', toWareHouseId: '', remark: '',
    lineList: [{ productId: '', wareHouseId: '', wareAreaId: '', batchNo: '', palletId: '', quantity: 1 }]
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      types: [
        { value: '01', label: '领料' }, { value: '02', label: '退料' }, { value: '03', label: '移库' },
        { value: '04', label: '生产入库' }, { value: '05', label: '发货出库' }, { value: '06', label: '采购入库' }
      ],
      query: { documentCode: '', documentType: '', approveStatus: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false, readonly: false,
      form: emptyForm(),
      warehouses: [], orders: [], products: [], pallets: [], areaMap: {},
      genVisible: false, genForm: { orderId: '', fromWareHouseId: '' }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看库存单据'
      return this.form.documentId ? '修改库存单据' : '新增库存单据'
    },
    needFrom() { return ['01', '03', '05'].indexOf(this.form.documentType) >= 0 },
    needTo() { return ['02', '03', '04', '06'].indexOf(this.form.documentType) >= 0 },
    fromLabel() { return this.form.documentType === '03' ? '移出仓' : '出库仓' },
    toLabel() { return this.form.documentType === '03' ? '移入仓' : '入库仓' }
  },
  created() {
    this.load()
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
    selectPallet().then(res => { this.pallets = res.data || [] }).catch(() => {})
    selectProductionOrder().then(res => { this.orders = res.data || [] }).catch(() => {})
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
  },
  methods: {
    sourceLabel(type) {
      return {
        MANUAL: '手工',
        SYSTEM: '系统生成',
        ORDER: '生产工单',
        PURCHASE_DELIVERY: '采购到货',
        SUBCONTRACT: '外协到货',
        DELIVERY: '发货',
        TRACKING: '生产报工',
        STOCKTAKING: '盘点',
        REPACK: '重包装'
      }[type] || type || ''
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listStockDocument({
        currentPage: this.page, pageSize: this.pageSize,
        documentCode: this.query.documentCode, documentType: this.query.documentType, approveStatus: this.query.approveStatus
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    addLine() { this.form.lineList.push({ productId: '', wareHouseId: '', wareAreaId: '', batchNo: '', palletId: '', quantity: 1 }) },
    lineWh(row) { return row.wareHouseId || this.form.fromWareHouseId || this.form.toWareHouseId },
    areasOf(row) { return this.areaMap[this.lineWh(row)] || [] },
    loadAreas(wareHouseId) {
      if (!wareHouseId || this.areaMap[wareHouseId]) return
      listWareArea({ wareHouseId, pageSize: 200 }).then(res => {
        const list = ((res.data && res.data.list) || []).filter(a => a.type === '1')
        this.$set(this.areaMap, wareHouseId, list)
      }).catch(() => {})
    },
    productLabel(id) {
      const p = (this.products || []).find(x => x.productId === id)
      if (p) return (p.productNumber || '') + (p.productName ? ' / ' + p.productName : '')
      return id || '-'
    },
    wareHouseLabel(id) {
      if (!id) return '-'
      const w = (this.warehouses || []).find(x => x.wareHouseId === id)
      return w ? w.wareHouseName : id
    },
    palletLabel(id) {
      if (!id) return '-'
      const p = (this.pallets || []).find(x => x.palletId === id)
      return p ? (p.palletCode + (p.palletName ? ' / ' + p.palletName : '')) : id
    },
    openView(id) { this.loadDetail(id, true) },
    openEdit(id) {
      if (!id) {
        this.readonly = false
        this.form = emptyForm()
        this.visible = true
        return
      }
      this.loadDetail(id, false)
    },
    loadDetail(id, readonly) {
      getStockDocument(id).then(res => {
        const d = res.data || {}
        this.readonly = !!readonly
        this.form = {
          documentId: d.documentId, documentCode: d.documentCode, documentType: d.documentType,
          documentDate: d.documentDate, orderId: d.orderId || '', fromWareHouseId: d.fromWareHouseId || '',
          toWareHouseId: d.toWareHouseId || '', remark: d.remark || '',
          lineList: (d.lineList && d.lineList.length) ? d.lineList.map(l => ({
            productId: l.productId || l.materialId || '',
            productNumber: l.productNumber || '',
            productName: l.productName || '',
            wareHouseId: l.wareHouseId || '',
            wareHouseName: l.wareHouseName || '',
            wareAreaId: l.wareAreaId || '',
            wareAreaName: l.wareAreaName || '',
            batchNo: l.batchNo || '',
            palletId: l.palletId || '',
            quantity: Number(l.quantity)
          })) : []
        }
        this.visible = true
      })
    },
    submit() {
      const lines = (this.form.lineList || []).filter(l => l.productId && Number(l.quantity) > 0)
      if (!lines.length) { this.$message.warning('请添加明细'); return }
      this.saving = true
      const payload = { ...this.form, lineList: lines }
      const req = this.form.documentId ? updateStockDocument(payload) : saveStockDocument(payload)
      req.then(() => {
        this.$message.success('操作成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    openGenerate() { this.genForm = { orderId: '', fromWareHouseId: '' }; this.genVisible = true },
    doGenerate() {
      if (!this.genForm.orderId || !this.genForm.fromWareHouseId) {
        this.$message.warning('请选择工单与仓库')
        return
      }
      generateIssueFromOrder(this.genForm.orderId, this.genForm.fromWareHouseId).then(res => {
        this.$message.success('已生成领料草稿')
        this.genVisible = false
        this.search()
        if (res.data && res.data.documentId) this.openEdit(res.data.documentId)
      })
    },
    approveRow(id) {
      this.$confirm('审核后将按类型增减库存，确定继续?', '提示', { type: 'warning' }).then(() => {
        approveStockDocument(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    unapproveRow(id) {
      this.$confirm('弃审将回滚库存，确定继续?', '提示', { type: 'warning' }).then(() => {
        unapproveStockDocument(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteStockDocument([id]).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
